module.exports = __webpack_public_path__ + "img/img5.183c5e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/img5.png
// module id = 398
// module chunks = 0